import { openModal } from '../open-modal'
import { Filename } from './types'
import { elements } from './elements'
import { addAvailableFiles, addFile, COPY_FILE, createFileInstance, LS_KEYS, updateLastUploadedFiles } from './ls'
import { parseFiles } from './api'
import { showErrors } from '../open-error-modal'

export const uploadRTF = async (context, window) => {
    const files = elements.uploadRTF.files
    if (!files || files.length == 0) return
    const filesToUpload: Array<Filename> = []
    const data = new FormData()
    for (const file of files as unknown as Array<File>) {
        data.append('file', file, file.name)
        filesToUpload.push(file.name as Filename)
    }
    data.append('byPages', 'true')
    elements.uploadRTF.value = ''
    const {
        modalWindow,
        command,
        styles,
    } = await openModal(context, window, {
        files: filesToUpload,
        inited: false,
    })
    const authKey = elements.authKey.value
    parseFiles(authKey, data).then(result => {
        const lastUploadedFiles: Array<Filename> = []
        for (const [filename, tables] of Object.entries(result)) {
            const fn = COPY_FILE(filename as Filename, tables)
            lastUploadedFiles.push(fn)
        }
        updateLastUploadedFiles(lastUploadedFiles)
        command('onFilesAvailable', {files: lastUploadedFiles, styles})
    }).catch(err => {
        modalWindow.close()
        showErrors(context, window, [err.message]) 
    })
}

